module.exports = __webpack_public_path__ + "img/vrexample.d9ae28ee.jpg";